import React from 'react';
import FooterImg from '../../assets/images/MadeWithLove.svg';
import { useFooterStyles } from './styles';
const PageFooter = () => {
    const ownClasses = useFooterStyles();
    return (React.createElement("footer", { className: ownClasses.root },
        React.createElement(FooterImg, { className: ownClasses.image })));
};
export default PageFooter;
